<template>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th>{{ $t('Code') }}</th>
          <th></th>
        </tr>
      </thead>
      <Sortable
        :list="items"
        item-key="id"
        tag="tbody"
        :options="{handle:'.draggable-handle'}"
        @end="updateOrder"
      >
        <template #item="{element: activityOption, index}">
          <tr :key="activityOption.id">
            <td style="width: 20px">
             <span class="draggable-handle">
                <i class="fa fa-sort" aria-hidden="true"></i>
              </span>
            </td>
            <td>
              {{ activityOption.code }}
            </td>
            <td>
              <a :href="editLink(activityOption.id)" class="btn btn-outline-primary">
                {{ $t('Edit') }}
              </a>
            </td>
          </tr>
        </template>
      </Sortable>
    </table>
  </div>
</template>

<script>
import { Sortable } from "sortablejs-vue3";

export default {
  components: {
    Sortable,
  },
  data() {
    return {
      items: [],
    }
  },
  props: [
    'activityOptionValues',
    'urls',
  ],
  methods: {
    editLink(id) {
      return  this.urls.edit.replace(':id', id);
    },
    updateOrder(event) {
      this.items.splice(event.newIndex, 0, this.items.splice(event.oldIndex, 1)[0]);

      axios.put(this.urls.order, {
        order: this.items.map((item) => item.id)
      })
      .catch(function (error) {
        alert(error);
      });
    }
  },
  mounted() {
    this.items = this.activityOptionValues;
  }
}
</script>

<style scoped>

</style>
